// src/lib/useAIFill.js
// AI form fill - calls Cloud Function (server-side) not Anthropic directly
import { useState } from 'react';
import { callAIFormFill } from './firebase';

export const useAIFill = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fill = async (input) => {
    if (!input?.trim()) return null;
    setLoading(true);
    setError(null);
    try {
      const result = await callAIFormFill({ input });
      return result.data?.data || null;
    } catch (err) {
      setError(err?.message || 'Could not read the event details. Please fill in manually.');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { fill, loading, error };
};
